import { render, staticRenderFns } from "./listLearningCentre.vue?vue&type=template&id=cc4021c0&"
import script from "./listLearningCentre.vue?vue&type=script&lang=js&"
export * from "./listLearningCentre.vue?vue&type=script&lang=js&"
import style0 from "./listLearningCentre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports